<form [formGroup]="addressFormGroup" fxLayout="column" *ngIf="address">
  <mat-form-field id="Country" *ngIf="!isHidden.Country" appearance="outline" floatLabel="always" fxFlex="100%">
    <mat-label [required-aria]="isRequired.Country">Country</mat-label>
    <mat-select
      [placeholder]="isRequired.Country ? 'Required' : ''"
      [formControl]="addressFormGroup.controls.country"
      (selectionChange)="address.countryChanged()"
    >
      <mat-option value="">Select</mat-option>
      <mat-option *ngFor="let country of address.countries" [value]="country.code">
        {{ country.name }}
      </mat-option>
    </mat-select>
    <mat-error *ngIf="addressFormGroup.controls.country.hasError('notEmpty')">
      {{ addressFormGroup.controls.country.getError('notEmpty') }}
    </mat-error>
  </mat-form-field>

  <mat-form-field *ngIf="!isHidden.Address1" id="Address1" appearance="outline" floatLabel="always" fxFlex="100%">
    <mat-label [required-aria]="isRequired.Address1">Street Address 1</mat-label>
    <input
      matInput
      forbidAngleBrackets
      type="text"
      [formControl]="addressFormGroup.controls.streetAddress1"
      [placeholder]="isRequired.Address1 ? 'Required' : ''"
      autocomplete="address-line1"
    />
    <mat-error *ngIf="addressFormGroup.controls.streetAddress1.hasError('notEmpty')">
      {{ addressFormGroup.controls.streetAddress1.getError('notEmpty') }}
    </mat-error>
  </mat-form-field>

  <mat-form-field *ngIf="!isHidden.Address1" id="Address2" appearance="outline" floatLabel="always" fxFlex="100%">
    <mat-label>Street Address 2</mat-label>
    <input
      matInput
      forbidAngleBrackets
      type="text"
      [formControl]="addressFormGroup.controls.streetAddress2"
      autocomplete="address-line2"
    />
  </mat-form-field>

  <div fxLayoutAlign="space-between" *ngIf="!isHidden.StateOrProvince || !isHidden.City">
    <mat-form-field
      id="City"
      appearance="outline"
      floatLabel="always"
      fxFlex="{{ address.regionVisible || isHidden.StateOrProvince ? '100%' : '70%' }}"
      *ngIf="!isHidden.City"
    >
      <mat-label [required-aria]="isRequired.City">City</mat-label>
      <input
        matInput
        forbidAngleBrackets
        type="text"
        [formControl]="addressFormGroup.controls.city"
        [placeholder]="isRequired.City ? 'Required' : ''"
        autocomplete="address-level2"
      />
      <mat-error *ngIf="addressFormGroup.controls.city.hasError('notEmpty')">
        {{ addressFormGroup.controls.city.getError('notEmpty') }}
      </mat-error>
    </mat-form-field>
    <mat-form-field
      id="StateOrProvince"
      *ngIf="!address.regionVisible && !isHidden.StateOrProvince"
      floatLabel="always"
      appearance="outline"
      [fxFlex]="isHidden.City ? '100%' : '25%'"
    >
      <mat-label [required-aria]="isRequired.StateOrProvince">{{ address.getLabel() }}</mat-label>
      <mat-select
        [placeholder]="isRequired.StateOrProvince ? 'Required' : ''"
        [formControl]="addressFormGroup.controls.stateOrRegion"
      >
        <mat-option value="">Select</mat-option>
        <mat-option *ngFor="let state of address.getStatesOrProvinces()" [value]="state.code">
          {{ state.name }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="addressFormGroup.controls.stateOrRegion.hasError('notEmpty')">
        {{ addressFormGroup.controls.stateOrRegion.getError('notEmpty') }}
      </mat-error>
    </mat-form-field>
  </div>
  <mat-form-field
    id="StateOrProvince"
    *ngIf="address.regionVisible"
    appearance="outline"
    floatLabel="always"
    fxFlex="100%"
  >
    <mat-label [required-aria]="isRequired.StateOrProvince">State / Region / Province</mat-label>
    <input
      matInput
      forbidAngleBrackets
      type="text"
      [formControl]="addressFormGroup.controls.stateOrRegion"
      [placeholder]="isRequired.StateOrProvince ? 'Required' : ''"
    />
    <mat-error *ngIf="addressFormGroup.controls.stateOrRegion.hasError('notEmpty')">
      {{ addressFormGroup.controls.stateOrRegion.getError('notEmpty') }}
    </mat-error>
  </mat-form-field>

  <mat-form-field id="PostalCode" *ngIf="!isHidden.PostalCode" appearance="outline" floatLabel="always" fxFlex="100%">
    <mat-label [required-aria]="isRequired.PostalCode">Postal Code</mat-label>
    <input
      matInput
      forbidAngleBrackets
      type="text"
      [formControl]="addressFormGroup.controls.postalCode"
      [placeholder]="isRequired.PostalCode ? 'Required' : ''"
      autocomplete="postal-code"
    />
    <mat-error *ngIf="addressFormGroup.controls.postalCode.hasError('notEmpty')">
      {{ addressFormGroup.controls.postalCode.getError('notEmpty') }}
    </mat-error>
  </mat-form-field>

  <mat-checkbox id="AddressIsShared" *ngIf="false" [formControl]="addressFormGroup.controls.isShared" color="primary">{{
    address.isSharedLabel
  }}</mat-checkbox>
</form>
